import {getDefaultConfig} from '@utils/omicron';

import {OmicronConfigSchema, OmicronContent, OmicronDTO} from './types';

export const OMICRON_CONFIG_API = '/omicron/config';
export const OMICRON_CONFIG_API_AB = '/api/v1';

export const OMICRON_DEFAULT_RESPONSE: OmicronDTO = {
  config_v: 270,
  cond_s: 'dd64cd17f792a9693686a51f060f77c16b80024cf707206fc8fe4bbc8ae5e4bf',
  config: getDefaultConfig<OmicronContent>(OmicronConfigSchema),
  segments: {},
};

export const OMICRON_PARAMS = 'omicronParams';
export const USER_ID = 'userId';
